import { useTranslation } from "react-i18next";

import { USER_ROLE_REFERENTIAL } from "@/entities/user-role";

export default function () {
  const { t } = useTranslation();

  return {
    filterMode: "tree",
    filters: USER_ROLE_REFERENTIAL.map(({ name }) => {
      return {
        text: t(`role:${name.replace(".", "")}`),
        value: name,
      };
    }),
  };
}
